import styled from "styled-components";

export const Wrapper = styled("div")`
  max-width: 960px;
  width: 100%;
  padding: 0 1em;
  margin-left: auto;
  margin-right: auto;
`;

export const TinyWrapper = styled("div")`
  padding: 0 1em;
  max-width: 650px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const SmallWrapper = styled("div")`
  padding: 0 1em;
  max-width: 765px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const BigBlackHeading = styled("div")`
  font-weight: 900;
  font-size: 3.0rem;
  letter-spacing: 0;
  line-height: 3.375rem;
`;

export const imgBoxShadow = "0 2px 4px 0 rgba(0,0,0,0.50)";

export const PotImage = styled("img")`
  @media only screen and (max-width: 1023px) {
    display: none;
  }
`;
